/* eslint-disable */
import { UsersClient } from "../proto/components_grpc_web_pb"
import {
  MailingList,
  ListUserRequest,
  GetUserRequest,
  DeleteUserRequest,
  CreateUserRequest,
  User,
  Auth,
  UpdateRequest,
  RemoveIntegrationRequest,
  DeleteUserWithAuthRequest
} from "../proto/components_pb"
import { frontendProxy } from "../../configs"
import { cleanUndefinedFromObject } from "./utils"

export default class UsersAPI {
  /**
   * init the components api hook via grpc to components service
   */
  constructor(jwt) {
    if (jwt) {
      this.jwt = jwt
      this.baseMetadata = { authorization: `Bearer ${jwt}` }
      this.client = new UsersClient(frontendProxy)
    } else {
      throw new Error("jwt is required")
    }
  }

  /**
   * Get all user
   *
   * @returns {Promise.<*>} - promise of list of users.
   */
  list() {
    // request
    const self = this
    const request = new ListUserRequest()

    // make request -> users list
    return new Promise((resolve, reject) => {
      self.client.list(request, this.baseMetadata, (err, res) => {
        err
          ? reject(err)
          : resolve(
              res.getUsersList().map((org) => {
                const obj = org.toObject()
                cleanUndefinedFromObject(obj)
                return obj
              })
            )
      })
    })
  }

  /**
   * Get specific User.
   *
   * @param {string} userId - user's id
   * @returns {Promise.<*>} - promise of user.
   */
  get(userId) {
    // request
    const self = this

    // set request
    const request = new GetUserRequest()
    request.setId(userId)

    // make request -> user
    return new Promise((resolve, reject) => {
      self.client.get(request, this.baseMetadata, (err, res) => {
        err ? reject(err) : resolve(cleanUndefinedFromObject(res.toObject()))
      })
    })
  }

  /**
   * Delete user
   *
   * @param {string} userId - user's id
   */
  delete(userId) {
    // request
    const self = this

    // set request
    const request = new DeleteUserRequest()
    request.setId(userId)

    // make request -> user
    return new Promise((resolve, reject) => {
      self.client.delete(request, this.baseMetadata, (err, res) => {
        err ? reject(err) : resolve(res.toObject())
      })
    })
  }

  /**
   * Create user
   *
   * @param {object} user - user object
   * @returns {Promise.<*>} - promise
   */
  create(user) {
    // request
    const self = this

    // get request
    const request = this._getUserObject(user)

    // make request -> user
    console.log("sending request with this metadata", this.baseMetadata)
    return new Promise((resolve, reject) => {
      self.client.create(request, this.baseMetadata, (err, res) => {
        err ? reject(err) : resolve(res.toObject())
      })
    })
  }

  /**
   * update user
   *
   * @param {object} user - user object
   * @param {Object} options
   * @returns {Promise.<*>} - promise
   */
  update(id, user, options = {}) {
    // request
    const self = this

    // define request
    const request = new UpdateRequest()

    // set user's id
    request.setId(id)

    // set ignore flatten
    if (options.ignore_flatten) {
      request.setIgnoreFlatten(options.ignore_flatten)
    }

    // set user's object
    const userRequest = this._getUserObject(user, "update")
    request.setUser(userRequest)

    // make request -> user
    return new Promise((resolve, reject) => {
      self.client.update(request, this.baseMetadata, (err, res) => {
        err ? reject(err) : resolve(res.toObject())
      })
    })
  }

  /**
   * Remove integration
   *
   * @param {string} id - user id
   * @param {object} data - data
   * @returns {Promise.<*>} - promise
   */
  removeIntegration(data) {
    // request
    const self = this

    // define request
    const request = new RemoveIntegrationRequest()

    // set data
    request.setUserId(data.userId)
    request.setOrgId(data.orgId)
    request.setIntegrationType(data.integrationType)
    request.setIntegrationLevel(data.integrationLevel)
    console.log("requestt", request)
    // make request -> remove
    return new Promise((resolve, reject) => {
      self.client.removeIntegration(request, this.baseMetadata, (err, res) => {
        err ? reject(err) : resolve(res.toObject())
      })
    })
  }

  /**
   * deleteWithFbAuth delete user record
   * includes fb-auth.
   * if uid provided - auth will be deleted
   * if userFsId provided - user's firestore record will be deleted
   *
   * @param {string} uid
   * @param {string} userFsId
   */
  deleteUserWithAuth(uid, userFsId) {
    // destract contect
    const self = this

    // define request
    const request = new DeleteUserWithAuthRequest()

    // add properties
    request.setUid(uid)
    request.setUserFsId(userFsId)

    // make request
    return new Promise((resolve, reject) => {
      self.client.deleteUserWithAuth(request, this.baseMetadata, (err, res) => {
        err ? reject(err) : resolve(res.toObject())
      })
    })
  }

  /**
   * Get user's request object
   *
   * @param {object} user - user's object
   * @returns {User} - proto User request object.
   */
  _getUserObject(user, requestType = "") {
    console.log("user", user)

    // init request object
    const resuestObject = new CreateUserRequest()

    // set request
    const userObj = new User()

    // set properties
    if (user.consoleLang) userObj.setConsoleLang(user.consoleLang)
    if (user.firstName) userObj.setFirstName(user.firstName)
    if (user.lastName) userObj.setLastName(user.lastName)
    if (user.mobiles) userObj.setMobilesList(user.mobiles)
    if (user.botLang) userObj.setBotLang(user.botLang)
    if (user.emails) userObj.setEmailsList(user.emails)
    if (user.orgs) userObj.setOrgsList(user.orgs)
    if (user.path) userObj.setPath(user.path)
    if (user.id) userObj.setId(user.id)

    // set mailing
    if (Object.keys(user.mailing || {}).length) {
      // define mailing list object
      const mailingListObj = new MailingList()

      // pull emails list
      const emailsList = Object.values(user.mailing)[0].values || []

      // set emails list to mailinglist object
      mailingListObj.setValuesList(emailsList)

      // pull key
      const key = Object.keys(user.mailing)[0]

      // set to user's object
      userObj
        .getMailingMap()
        .set(key, mailingListObj)
    }

    // set hubspot
    if (Object.keys(user.hubspot || {}).length)
      userObj
        .getHubspotMap()
        .set(Object.keys(user.hubspot)[0], Object.values(user.hubspot)[0])

    // set salesforce
    if (Object.keys(user.salesforce || {}).length)
      userObj
        .getSalesforceMap()
        .set(Object.keys(user.salesforce)[0], Object.values(user.salesforce)[0])

    // set zapier map
    if (Object.keys(user.zapier || {}).length)
      userObj
        .getZapierMap()
        .set(Object.keys(user.zapier)[0], Object.values(user.zapier)[0])

    // set mobile country code
    if (user.mobiles_country_code)
      userObj.setMobilesCountryCode(user.mobiles_country_code)

    if (user.auth) {
      const authObj = new Auth()
      authObj.setPassword(user.auth.password)
      authObj.setSeed(user.auth.seed)
      authObj.setAccessLevel(user.auth.accessLevel)

      // attach to user
      userObj.setAuth(authObj)
    }

    resuestObject.setUser(userObj)
    return requestType === "update" ? userObj : resuestObject
  }
}
